import styled from "styled-components"
import { showModal } from "../../features/modal/modalSlice";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { pdf } from "@react-pdf/renderer";
import getCurrentTime from "../../helper/getCurrentTime";
import getCurrentDate from "../../helper/getCurrentDate";
import { setLoadItemSelect, setShipmentData } from "../../features/loadList/loadListSlice";
import { useNavigate } from "react-router-dom";
import ShipmentPDFViewer from "./ShipmentPDFViewer";
import Btn from "../shared/button/Btn";
import { sendMail } from "../../features/joblist/jobListSlice";
import TasimaSenediShipmentPDF from "../pdf/TasimaSenediShipmentPDF";
import SmallSpinner from "../shared/spinners/SmallSpinner";

const Container = styled.div`
    display: flex;
    gap: 40px;
    margin-top: 20px;


    .sended-type-item{
        display: flex;
        border: 2px solid var(--color-main);
        border-radius: 10px;
        overflow: hidden;

        input{
            width: 240px;
            padding: 5px 15px;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            color: ${({theme}) => theme.mainTextColor};

        }
    }
`

const ShipmentMektupSender = () => {

    const dispatch = useDispatch()
    const [mailAdres, setMailAdres] = useState("");
    const [activeSendedType, setActiveSendedType] = useState(null);
    const { shipmentData } = useSelector(state => state.loadList);
    const {isLoadingSendMail} = useSelector(state => state.jobList)

    const [blob, setBlob] = useState()

    
    const sendWithMail = () => {
        if(blob && mailAdres){

            
            dispatch(sendMail({
                file:blob,
                mail: mailAdres,
                yukId: shipmentData.waitinLoadId,
                fileName: shipmentData?.waitinLoad?.aspiredLoads?.$values[0]?.truckPlateNumber ? `${getCurrentDate()}-${getCurrentTime()}-${shipmentData?.waitinLoad?.aspiredLoads?.$values[0]?.truckPlateNumber}` : `${getCurrentDate()}-${getCurrentTime()}`,
                fromShipment: true
            }))
        }
    }


    useEffect(() => {
        const generatePDFBlob = async () => {
            try {
                // const blob = await pdf(<TasimaSenediPDF />).toBlob().then((blob) => saveAs(blob, "YourFileName.pdf"));
                const blob = await pdf(<TasimaSenediShipmentPDF data={shipmentData} />).toBlob();
                //   saveAs(blob, "Asdas1234.pdf")
              setBlob(blob)
            } catch (error) {
              console.error("PDF oluşturulurken hata oluştu:", error);
              throw error;
            }
          };
          generatePDFBlob()
    },[])

  return (
    <Container>
    {/* <PDFDownloadLink document={<TasimaSenediPDF />} fileName="asdasasadasasa">
        {({ loading }) => (loading ? <button>loading doc</button> : <button>download</button>)}
    </PDFDownloadLink> */}
        {
            activeSendedType === "mail" ?
            <div className="sended-type-item">
                <input type="text" onChange={(e) => setMailAdres(e.target.value)} value={mailAdres} placeholder="Mail Adresi Girin"/>
                <Btn handleClick={() => {sendWithMail(); setActiveSendedType(null)}} color="#fff" width={"200px"} radius="0" bgColor="#E85546">Gönder</Btn>
            </div>
            : 
            <Btn handleClick={() => setActiveSendedType("mail")} color="#fff" width={"200px"} height="44px" bgColor="#E85546" >{isLoadingSendMail ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Mail ile Gönder"}</Btn>
        }
        <Btn handleClick={() => {dispatch(showModal(null)); dispatch(setShipmentData(null));}} color="#fff" width={"200px"} height="44px" bgColor="#E85546" >Kapat</Btn>
    </Container>
  )
}

export default ShipmentMektupSender